export const dataURItoBlob = (dataURI) => {
    var byteString = atob(dataURI.split(',')[1]);
    var mimeString = dataURI.split(',')[0].split(':')[1].split(';')[0]
    var ab = new ArrayBuffer(byteString.length);
    var ia = new Uint8Array(ab);
    for (var i = 0; i < byteString.length; i++) {
        ia[i] = byteString.charCodeAt(i);
    }
    var blob = new Blob([ab], {type: mimeString});
    return blob;
}

export const addNullForEmptyField = (obj) => {
    for (let i in obj) {
        if (!obj[i]) obj[i] = null;
    }

    return obj;
}

export const updateQuery = ({benefitId, page, filter, size, sort}) => {
    let query = '';
    
    if(typeof page !== undefined){
        query += `?page=${page}`;
    }

    if(size){
        query += query ? '&' : `?`;
        query += `size=${size}`;
    }
    if(benefitId){
        query += query ? '&' : `?`;
        query += `benefitId=${benefitId}`;
    }
    if(sort && sort.length){
        query += query ? '&' : `?`;
        sort.forEach((val) => {
            query += `sort=${val.field},${val.sort}`
        })
    }
    if(filter && filter.items && filter.items.filter((item) => item.value).length){
        query += query ? '&' : `?`;

        filter.items.filter((item) => item.value).forEach(({columnField, value}) => {
            query += `${columnField}=${value}`
        })
    }

    return query
}

export const mergeCategories = (benefits) => {
    benefits.forEach((benefit) => {
        if(benefit.subCategory){
            benefit.category = benefit.subCategory
        }
    })
    benefits.forEach((benefit) => {
        delete benefit.subCategory
    })
}

export const mergeCategory = (benefit) => {
    if(benefit.subCategory){
        benefit.category = benefit.subCategory
    }
}